@if (!showAsChip()) {
	<form-field-label [labelTranslateKey]="'category'" />
	<mat-form-field appearance="outline" class="category-container">
		<mat-select
			hideSingleSelectionIndicator="true"
			[formControl]="category"
			[placeholder]="placeholder() | translate"
		>
			<mat-select-trigger class="selected-category">
				{{ category.value.value | translate }}
				@if (showRemoveButton() && category.value.value) {
					<mat-icon
						class="cursor-pointer"
						svgIcon="close"
						(click)="category.setValue({ key: null, value: 'category_none' })"
					/>
				}
			</mat-select-trigger>
			<mat-option>
				<ngx-mat-select-search
					class="category-search"
					[formControl]="categorySearch"
					[placeholderLabel]="'search' | translate"
					[noEntriesFoundLabel]="'no_results_found' | translate"
				/>
			</mat-option>
			@for (category of defaultCategories(); track category.key) {
				<mat-option [value]="category" class="category-option">
					{{ category.value | translate }}
				</mat-option>
			}
		</mat-select>
	</mat-form-field>
} @else {
	<mat-chip [aria-label]="'category' | translate" [matMenuTriggerFor]="categoryMenu">
		<div class="category-chip">
			@if (!category.value.key) {
				{{ 'category' | translate }}
			} @else {
				{{ category.value.value | translate }}
			}
		</div>
	</mat-chip>

	<mat-menu #categoryMenu="matMenu" class="category-menu">
		@for (categoryItem of defaultCategories(); track categoryItem.key) {
			<button mat-menu-item (click)="category.setValue(categoryItem)">
				{{ categoryItem.value | translate }}
			</button>
		}
	</mat-menu>
}
